<po-page-change-password [p-hide-current-password]="true" p-logo="logo.png" p-secondary-logo="logo.png"
    [p-url-new-password]="serviceApi" [p-requirements]="poPageChangePasswordRequirement">
</po-page-change-password>